import React from 'react'

export default function ResultAnalyticalB(props) {
  return (
    <div className='results-container'>
        {props.children}
    </div>
  )
}
